// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cellText[data-v-ff154a08] {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.icon-more[data-v-ff154a08] {\n  background-color: var(--color-main-background);\n  background-image: var(--icon-more-000);\n  border: 0;\n}\n.button[data-v-ff154a08]:focus {\n  background-color: var(--color-background-dark);\n}\n", ""]);
// Exports
module.exports = exports;
